import { MessageCircle } from "lucide-react";

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "917836874807";
const WA_MSG = encodeURIComponent(
    "Hi Lead Krafts, I want to understand verified real-estate lead pricing for my project."
);

export default function FloatingWhatsApp() {
    const href = `https://wa.me/${WA_NUMBER}?text=${WA_MSG}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 flex items-center gap-2 pl-4 pr-5 py-3 bg-[#25D366] hover:bg-[#1FBA57] text-white shadow-[0_10px_40px_rgba(37,211,102,0.35)] transition-transform hover:-translate-y-0.5"
        >
            <MessageCircle size={20} strokeWidth={2} />
            <span className="text-sm font-medium hidden sm:inline">Talk to a Lead Expert</span>
        </a>
    );
}
